import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unico'
})
export class UnicoPipe implements PipeTransform {

    // Devuelve un array con valores únicos

    transform<T>(array: T[], property?: string): T[] {
        if (!array) return [];

        if (property) {
            // Para objetos, usar una propiedad específica
            const seen = new Set();
            return array.filter(item => {
                const value = (item as Record<string, unknown>)[property];
                if (seen.has(value)) {
                    return false;
                }
                seen.add(value);
                return true;
            });
        } else {
            // Para valores primitivos
            return [...new Set(array)];
        }
    }
}